/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { TokenTransactionMetadata } from "./TokenTransactionMetadata.ts";

export const transactionCounterpartyTypeEnum = {
	spark: "spark",
	lightning: "lightning",
	bitcoin: "bitcoin",
	token: "token",
} as const;

export type TransactionCounterpartyTypeEnum =
	(typeof transactionCounterpartyTypeEnum)[keyof typeof transactionCounterpartyTypeEnum];

export type TransactionCounterparty = {
	/**
	 * @type string
	 */
	type: TransactionCounterpartyTypeEnum;
	/**
	 * @type string
	 */
	identifier: string;
	/**
	 * @type string
	 */
	pubkey?: string | null;
	/**
	 * @type object
	 */
	tokenMetadata?: TokenTransactionMetadata | null;
};
